import axios from "axios"
import { useAppState } from "../redux"
import { useQuery } from "react-query"
import { QueryKeys } from "../../constants/query-keys"

export const useReviewVersionMatchSummaries = (id: string) => {
  const appState = useAppState()
  const { csrf_timestamp, csrf_token, masterAccountId } = appState.session

  const getVersionMatchSummaries = async (): Promise<any | undefined> => {
    const response = await axios.get(`/cms/api/accounts/${masterAccountId}/global-job-pricing/versions/${id}/review-match-summaries?csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`)
    return response?.data?.data
  }

  const query = useQuery([QueryKeys.GLO_JAM_REVIEW_MATCH_SUMMARIES, { id }], getVersionMatchSummaries)

  return query
}

